import {
  Configuration as MsalConfig,
  LogLevel,
  RedirectRequest,
} from '@azure/msal-browser';
import { Configuration } from '../../../config';

const {
  config: { CLIENT_ID, AUTHORITY },
} = new Configuration();

export const msalConfig: MsalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    knownAuthorities: [AUTHORITY],
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    // storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    iframeHashTimeout: 2400000,
    allowRedirectInIframe: true,
    tokenRenewalOffsetSeconds: 1200000,
    redirectNavigationTimeout: 1200000,
    windowHashTimeout: 1200000,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            // console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            // console.debug(message);
            return;
          case LogLevel.Warning:
            // console.warn(message);
            return;
        }
      },
    },
  },
};

export const loginRedirectRequest: RedirectRequest = {
  scopes: ['openid', 'profile', CLIENT_ID],
  redirectUri: window.location.origin,
};

export const loginRedirectRequestMFA: RedirectRequest = {
  scopes: ['openid', 'profile', CLIENT_ID],
  authority: AUTHORITY,
  redirectUri: window.location.origin,
  extraQueryParameters: { is_managing: 'true' },
};
